"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Legend = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _LegendMixin = require("../../mixins/components/LegendMixin");
var _Label = require("../Label/Label");
/**
 * An HTML [legend element](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/legend).
 *
 * `Legend` extends the `Label` component and is used
 * to caption a group of controls within a `FieldSet`.
 *
 * @extends Label
 * @since 8.0.0
 */
var Legend = /*#__PURE__*/(0, _styledComponents.default)(_Label.Label).attrs({
  forwardedAs: 'legend'
}).withConfig({
  displayName: "Legend",
  componentId: "c11n-8-109-1__sc-1fo3js-0"
})(["", ""], _LegendMixin.LegendMixin);
exports.Legend = Legend;
Legend.displayName = 'Legend';

/** @component */